export const iconFontAwesomeCharityHandHoldingDroplet = (
	<i className="fa-solid fa-hand-holding-droplet"></i>
);
